const mainComponent = document.querySelector("#wl-game-integration-plugin");

if (mainComponent) {
  Promise.all([
    hookLiveTournaments(),
    hookFeatureTournaments(),
    hookUpcomingTournaments(),
  ])
    .then(() => {
      checkPluginElHeight();
      showAlertBlock();
      tournamentTimer();
      tournamentBlocks();
      hookTournamentInfoBtn();
      hookTournamentCloseBtn();
      hookTournamentLeaderboardBtn();
      tournamentStartAndEndTime();
    })
    .catch((error) => {
      console.log("Error in tournament.js", error);
    });
  hookTournamentSchedule();
  hookTournamentResults();
  hookPlayerTournamentHistory();
}

function invertPriceCurrency(priceString) {
  if (!priceString) {
    return priceString;
  }
  const match = priceString.trim().match(/^([\d,]+)(\D+)$/);

  if (match) {
    return `${match[2].trim()}${match[1].trim()}`;
  }

  return priceString;
}

function hookTournamentInfoBtn() {
  let tournamentInfoBtn = document.querySelectorAll(
    "[data-homepage-tournament-info]"
  );

  tournamentInfoBtn.forEach((el) => {
    el.addEventListener("click", (e) => {
      let currentTarget = e.currentTarget;
      let tournamentId = currentTarget.dataset.homepageTournamentInfo;
      let tournamentMainDiv = document.querySelectorAll(
        '[data-tournament-main="' + tournamentId + '"]'
      );

      let tournamentInfoDiv = document.querySelector(
        '[data-tournament-info="' + tournamentId + '"]'
      );
      let tournamentLeaderboardDiv = document.querySelector(
        '[data-tournament-leaderboard="' + tournamentId + '"]'
      );
      let tournamentDiv = document.querySelector(
        '[data-tournament-id="' + tournamentId + '"]'
      );

      tournamentMainDiv.forEach((el) => {
        el.style.display = "none";
      });

      tournamentLeaderboardDiv.style.display = "none";
      tournamentInfoDiv.style.display = "block";
      tournamentDiv.classList.add("flip");
    });
  });
}

function hookTournamentCloseBtn() {
  let tournamentCloseBtn = document.querySelectorAll(
    "[data-homepage-tournament-close]"
  );
  tournamentCloseBtn.forEach((el) => {
    el.addEventListener("click", (e) => {
      let currentTarget = e.currentTarget;
      let tournamentId = currentTarget.dataset.homepageTournamentClose;
      let tournamentMainDiv = document.querySelectorAll(
        '[data-tournament-main="' + tournamentId + '"]'
      );
      let tournamentInfoDiv = document.querySelector(
        '[data-tournament-info="' + tournamentId + '"]'
      );
      let tournamentLeaderboardDiv = document.querySelector(
        '[data-tournament-leaderboard="' + tournamentId + '"]'
      );
      let tournamentDiv = document.querySelector(
        '[data-tournament-id="' + tournamentId + '"]'
      );

      tournamentInfoDiv.style.display = "none";
      tournamentLeaderboardDiv.style.display = "none";
      tournamentMainDiv.forEach((el) => {
        el.style.display = "";
      });
      tournamentDiv.classList.remove("flip");
    });
  });
}

function hookTournamentLeaderboardBtn() {
  let tournamentLeaderboardBtn = document.querySelectorAll(
    "[data-homepage-tournament-leaderboard]"
  );
  tournamentLeaderboardBtn.forEach((el) => {
    el.addEventListener("click", (e) => {
      let currentTarget = e.currentTarget;
      let tournamentId = currentTarget.dataset.homepageTournamentLeaderboard;
      let tournamentMainDiv = document.querySelectorAll(
        '[data-tournament-main="' + tournamentId + '"]'
      );
      let tournamentInfoDiv = document.querySelector(
        '[data-tournament-info="' + tournamentId + '"]'
      );
      let tournamentLeaderboardDiv = document.querySelector(
        '[data-tournament-leaderboard="' + tournamentId + '"]'
      );
      let tournamentDiv = document.querySelector(
        '[data-tournament-id="' + tournamentId + '"]'
      );

      tournamentMainDiv.forEach((el) => {
        el.style.display = "none";
      });
      tournamentInfoDiv.style.display = "none";
      tournamentLeaderboardDiv.style.display = "";
      tournamentDiv.classList.add("flip");
    });
  });
}

async function hookLiveTournaments() {
  const liveTournamentComponent = document.querySelector(
    "[data-live-tournaments]"
  );
  if (!liveTournamentComponent) {
    return;
  }
  let country = window.userCountry === "unknown" ? "" : window.userCountry;
  const parameters = {
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: settings.token,
      username: settings.username,
      license: settings.pp_wl_game_client_id,
    },
    // body: JSON.stringify({ country: country }),
  };
  let queryParams = {};
  if (country) {
    queryParams.country = country;
  }
  let queryParamsObj = new URLSearchParams(queryParams);
  let result;
  try {
    const response = await fetch(
      settings.rest_api_url + "getLiveTournaments/" + `?${queryParamsObj}`,
      parameters
    );
    if (response.ok) {
      const tournaments = await response.json();
      for (const tournament of tournaments.data) {
        tournament.prizePool = invertPriceCurrency(tournament.prizePool);
        if (tournament.prizePoolList?.length) {
          for (const prize of tournament.prizePoolList) {
            prize.prize = invertPriceCurrency(prize.prize);
          }
        }
      }
      result = tournaments;
    } else if (response.status == 401 || response.status == 403) {
      result = await response.json();
    } else {
      throw new Error("Could not reach the API: " + response.statusText);
    }

    if (result.success) {
      var data = result.data;
      let liveTournaments = data.filter(
        (tournament) => !tournament.isFeatureTournament
      );
      for (let liveTournament of liveTournaments) {
        if (
          liveTournament.actionButton &&
          liveTournament.actionButton.additionalHtml.includes(
            "data-wl-game-register-url"
          )
        ) {
          liveTournament.actionButton.url = settings.pp_wl_game_register_page;
        }
        if (
          liveTournament.actionButton &&
          liveTournament.actionButton.additionalHtml.includes(
            "data-wl-game-results-url"
          )
        ) {
          liveTournament.actionButton.url =
            settings.pp_wl_game_result_page +
            "?tournamentId=" +
            liveTournament.tournamentId;
        }
      }
      liveTournaments = liveTournaments.length == 0 ? false : liveTournaments;
      handlebarTemplateJS("#live-tournaments", "[data-live-tournaments]", {
        liveTournaments: liveTournaments,
      });
      

      let liveTournamentsDiv = document.querySelector(
        "[data-live-tournaments]"
      );

      liveTournamentsDiv.addEventListener("breakpoint", () => {
        tournamentBlocks();
      });
    } else {
      if (result.message && result.message == "Invalid License Received") {
        handlebarTemplateJS("#invalid-license", "[data-live-tournaments]", {});
      }
      if (result.message && result.message == "Country is blocked") {
        handlebarTemplateJS("#blocked-country", "[data-live-tournaments]", {});
      }
    }
  } catch (error) {
    console.error(error);
  }
}

async function hookFeatureTournaments() {
  const featureTournamentComponent = document.querySelector(
    "[data-feature-tournaments]"
  );
  if (!featureTournamentComponent) {
    return;
  }
  let country = window.userCountry === "unknown" ? "" : window.userCountry;

  let tournamentIdList = featureTournamentComponent.dataset.featureTournaments;
  if (!tournamentIdList) {
    return;
  }
  tournamentIdList =
    typeof tournamentIdList == "number"
      ? [tournamentIdList]
      : tournamentIdList.split(",");
  const parameters = {
    headers: {
      "content-type": "application/json",
      Authorization: settings.token,
      username: settings.username,
      license: settings.pp_wl_game_client_id,
    },
    method: "GET",
    //body: JSON.stringify({ tournamentIdList: tournamentIdList ,country:country})
  };
  let queryParams = {};
  if (country) {
    queryParams.country = country;
  }
  if (tournamentIdList) {
    queryParams.tournamentIdList = tournamentIdList.join(",");
  }
  let queryParamsObj = new URLSearchParams(queryParams);
  try {
    const response = await fetch(
      settings.rest_api_url + "getFeatureTournaments/?" + queryParamsObj,
      parameters
    );
    let result;
    if (response.ok) {
      result = await response.json();
    } else if (response.status == 401 || response.status == 403) {
      result = await response.json();
    } else {
      throw new Error("Could not reach the API: " + response.statusText);
    }

    if (result.success) {
      var data = result.data;

      handlebarTemplateJS(
        "#feature-tournaments",
        "[data-feature-tournaments]",
        { featureTournaments: data }
      );

      let tournamentInfoBtn = document.querySelectorAll(
        "[data-feature-tournament-info-btn]"
      );
      tournamentInfoBtn.forEach((el) => {
        el.addEventListener("click", (e) => {
          let currentTarget = e.currentTarget;
          let tournamentId = currentTarget.dataset.featureTournamentInfoBtn;
          let tournamentMainDiv = document.querySelectorAll(
            '[data-feature-tournament-main="' + tournamentId + '"]'
          );
          let tournamentInfoDiv = document.querySelector(
            '[data-feature-tournament-info="' + tournamentId + '"]'
          );
          let tournamentLeaderboardDiv = document.querySelector(
            '[data-feature-tournament-leaderboard="' + tournamentId + '"]'
          );
          let tournamentDiv = document.querySelector(
            '[data-feature-tournament-id="' + tournamentId + '"]'
          );

          tournamentMainDiv.forEach((el) => {
            el.style.display = "none";
          });
          tournamentLeaderboardDiv.style.display = "none";
          tournamentInfoDiv.style.display = "";
          tournamentDiv.classList.add("flip");
        });
      });
      let tournamentLeaderboardBtn = document.querySelectorAll(
        "[data-feature-tournament-leaderboard-btn]"
      );
      tournamentLeaderboardBtn.forEach((el) => {
        el.addEventListener("click", (e) => {
          let currentTarget = e.currentTarget;
          let tournamentId =
            currentTarget.dataset.featureTournamentLeaderboardBtn;
          let tournamentMainDiv = document.querySelectorAll(
            '[data-feature-tournament-main="' + tournamentId + '"]'
          );
          let tournamentInfoDiv = document.querySelector(
            '[data-feature-tournament-info="' + tournamentId + '"]'
          );
          let tournamentLeaderboardDiv = document.querySelector(
            '[data-feature-tournament-leaderboard="' + tournamentId + '"]'
          );
          let tournamentDiv = document.querySelector(
            '[data-feature-tournament-id="' + tournamentId + '"]'
          );

          tournamentMainDiv.forEach((el) => {
            el.style.display = "none";
          });
          tournamentInfoDiv.style.display = "none";
          tournamentLeaderboardDiv.style.display = "";
          tournamentDiv.classList.add("flip");
        });
      });
      let tournamentCloseBtn = document.querySelectorAll(
        "[data-feature-tournament-close]"
      );
      tournamentCloseBtn.forEach((el) => {
        el.addEventListener("click", (e) => {
          let currentTarget = e.currentTarget;
          let tournamentId = currentTarget.dataset.featureTournamentClose;
          let tournamentMainDiv = document.querySelectorAll(
            '[data-feature-tournament-main="' + tournamentId + '"]'
          );
          let tournamentInfoDiv = document.querySelector(
            '[data-feature-tournament-info="' + tournamentId + '"]'
          );
          let tournamentLeaderboardDiv = document.querySelector(
            '[data-feature-tournament-leaderboard="' + tournamentId + '"]'
          );
          let tournamentDiv = document.querySelector(
            '[data-feature-tournament-id="' + tournamentId + '"]'
          );

          tournamentInfoDiv.style.display = "none";
          tournamentLeaderboardDiv.style.display = "none";
          tournamentMainDiv.forEach((el) => {
            el.style.display = "";
          });
          tournamentDiv.classList.remove("flip");
        });
      });
    } else {
      if (result.message && result.message == "Invalid License Received") {
        handlebarTemplateJS("#invalid-license", "[data-live-tournaments]", {});
      }
      if (result.message && result.message == "Country is blocked") {
        handlebarTemplateJS("#blocked-country", "[data-live-tournaments]", {});
      }
    }
  } catch (error) {
    console.error(error);
  }
}

function hookPlayerTournamentHistory() {
  let page = document.querySelector("[data-page-profile-history]");
  if (!page) {
    return false;
  }

  var data;

  const parameters = {
    headers: {
      "content-type": "application/json",
      Authorization: settings.token,
      username: settings.username,
      license: settings.pp_wl_game_client_id,
    },
    method: "GET",
  };

  fetch(settings.rest_api_url + "getPlayerTournamentHistory/", parameters)
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else if (response.status == 401 || response.status == 403) {
        return response.json();
      } else {
        throw new Error("Could not reach the API: " + response.statusText);
      }
    })
    .then((result) => {
      if (result.success) {
        data = { tournaments: result.data };
        processPlayerTournamentHistory(1, data);
        playerTournamentHistoryPagination();
      } else {
        if (result.message && result.message == "Invalid License Received") {
          handlebarTemplateJS(
            "#invalid-license",
            "[data-page-tournament-results]",
            {}
          );
        }
        if (result.message && result.message == "Country is blocked") {
          handlebarTemplateJS(
            "#blocked-country",
            "[data-page-tournament-results]",
            {}
          );
        }
      }
    })
    .catch((error) => {
      console.error(error);
    });

  function playerTournamentHistoryPagination() {
    let paginationButton = page.querySelectorAll(
      "[data-page-tournament-history-pagination]"
    );
    paginationButton.forEach((element) => {
      element.addEventListener("click", (e) => {
        let currentTarget = e.currentTarget;
        let page = currentTarget.dataset.pageTournamentHistoryPagination;
        processPlayerTournamentHistory(page, data);
        smoothScroll("div[data-page-profile-history]");
      });
    });
  }

  function processPlayerTournamentHistory(page, data) {
    if (data && data.tournaments) {
      let tournaments = data.tournaments;
      let limit = 10;
      let firstResult = (page - 1) * limit;
      if (firstResult < 0) {
        firstResult = 0;
      }
      data.currentPage = page;
      data.maxPages = Math.ceil(tournaments.length / limit);
      data.paginationTournaments = tournaments.slice(firstResult, page * limit);
      if (data.maxPages > 10) {
        data.maxPagesToShow =
          page + 9 < data.maxPages
            ? range(page, page + 9)
            : range(data.maxPages - 9, data.maxPages);
      } else {
        data.maxPagesToShow = range(1, data.maxPages);
      }
      handlebarTemplateJS(
        "#page-profile-history",
        "[data-page-profile-history]",
        data
      );
      playerTournamentHistoryPagination();
    }
  }
}

function hookTournamentResults() {
  const tournamentResultsComponent = document.querySelector(
    "[data-page-tournament-results]"
  );
  if (!tournamentResultsComponent) {
    return false;
  }
  let country = window.userCountry === "unknown" ? "" : window.userCountry;
  var path = window.location.pathname;
  let urlArray = path.split("/");

  let tournamentId = urlArray[urlArray.length - 2];
  tournamentId = parseInt(tournamentId);
  if (!tournamentId) {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    tournamentId = params.get("tournamentId");
  }
  if (tournamentId) {
    hookTournamentSingleResults(tournamentId);
    return;
  }

  const parameters = {
    headers: {
      "content-type": "application/json",
      Authorization: settings.token,
      username: settings.username,
      license: settings.pp_wl_game_client_id,
    },
    method: "GET",
    //body: JSON.stringify({ 'page': 1, 'limit': 10 ,country:country}),
  };
  let queryParams = {};
  if (country) {
    queryParams.country = country;
  }
  queryParams.page = 1;
  queryParams.limit = 10;
  let queryParamsObj = new URLSearchParams(queryParams);
  fetch(
    settings.rest_api_url + "getTournamentResults/?" + queryParamsObj,
    parameters
  )
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else if (response.status == 401 || response.status == 403) {
        return response.json();
      } else {
        throw new Error("Could not reach the API: " + response.statusText);
      }
    })
    .then((result) => {
      processTournamentResults(result);
    })
    .catch((error) => {
      console.error(error);
    });

  function processTournamentResults(result) {
    if (result.success) {
      var data = {
        tournaments: result.data,
        maxPages: result.maxPages,
        currentPage: result.currentPage,
      };

      if (data.maxPages > 10) {
        data.maxPagesToShow =
          page + 9 < data.maxPages
            ? range(page, page + 9)
            : range(data.maxPages - 9, data.maxPages);
      } else {
        data.maxPagesToShow = range(1, data.maxPages);
      }
      if (result.data.length > 0) {
        handlebarTemplateJS(
          "#page-tournament-results",
          "[data-page-tournament-results]",
          data
        );
        processTournamentResultsPagination();
        showTournamentLeaderboard();
        triggerCollapse();
      }
    } else {
      if (result.message && result.message == "Invalid License Received") {
        handlebarTemplateJS(
          "#invalid-license",
          "[data-page-tournament-results]",
          {}
        );
      }
      if (result.message && result.message == "Country is blocked") {
        handlebarTemplateJS(
          "#blocked-country",
          "[data-page-tournament-results]",
          {}
        );
      }
    }
  }

  function showTournamentLeaderboard() {
    let tournamentLeaderboardBtn = tournamentResultsComponent.querySelectorAll(
      "[data-show-tounament-leaderboard]"
    );
    tournamentLeaderboardBtn.forEach((element) => {
      element.addEventListener("click", (e) => {
        let currentTarget = e.currentTarget;
        if (currentTarget.classList.contains("collapsed")) {
          return;
        }
        let tournamentId = currentTarget.dataset.showTounamentLeaderboard;
        hookTournamentSingleResults(tournamentId);
      });
    });
  }

  function processTournamentResultsPagination() {
    let paginationButton = tournamentResultsComponent.querySelectorAll(
      "[data-page-tournament-results-pagination]"
    );
    paginationButton.forEach((element) => {
      element.addEventListener("click", (e) => {
        let currentTarget = e.currentTarget;
        const parameters = {
          headers: {
            "content-type": "application/json",
            Authorization: settings.token,
            username: settings.username,
            license: settings.pp_wl_game_client_id,
          },
          method: "GET",
          //body: JSON.stringify({ 'page': currentTarget.dataset.pageTournamentResultsPagination, 'limit': 10, country:country}),
        };
        let queryParams = {};
        if (country) {
          queryParams.country = country;
        }
        queryParams.page =
          currentTarget.dataset.pageTournamentResultsPagination;
        queryParams.limit = 10;
        let queryParamsObj = new URLSearchParams(queryParams);
        fetch(
          settings.rest_api_url + "getTournamentResults/?" + queryParamsObj,
          parameters
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else if (response.status == 401 || response.status == 403) {
              return response.json();
            } else {
              throw new Error(
                "Could not reach the API: " + response.statusText
              );
            }
          })
          .then((result) => {
            if (result.success) {
              processTournamentResults(result);
            }
          });
      });
    });
  }
}

function smoothScroll(selector) {
  document.querySelector(selector).scrollIntoView({
    behavior: "smooth",
  });
}

function hookTournamentSingleResults(tournamentId) {
  // const tournamentResultsComponent = document.querySelector(
  //     '[data-single-results-page]'
  // );
  // const tournamentResultsComponentNew = document.querySelector(
  //     '[data-single-results-page-new]'
  // );
  // if (!tournamentResultsComponent && !tournamentResultsComponentNew) {
  //     return;
  // }
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  var isSinglePageResult =
    parseInt(params.get("tournamentId")) > 0 ? true : false;
  var data;

  let parameters = {
    headers: {
      "content-type": "application/json",
      Authorization: settings.token,
      username: settings.username,
      license: settings.pp_wl_game_client_id,
    },
    method: "GET",
    //body: JSON.stringify({ tournament_id: tournamentId }),
  };
  let queryParams = {};
  if (tournamentId) {
    queryParams.tournament_id = tournamentId;
  }
  let queryParamsObj = new URLSearchParams(queryParams);
  fetch(
    settings.rest_api_url + "getTournamentLeaderBoard/?" + queryParamsObj,
    parameters
  )
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else if (response.status == 401 || response.status == 403) {
        return response.json();
      } else {
        throw new Error("Could not reach the API: " + response.statusText);
      }
    })
    .then((result) => {
      if (result.success) {
        data = result.data;
        processSingleTournamentResults(1, result.data);
        singleTournamentResultsPagination();
      } else {
        if (result.message && result.message == "Invalid License Received") {
          handlebarTemplateJS(
            "#invalid-license",
            '[data-single-results-page="' + tournamentId + '"]',
            {}
          );
        }
        if (result.message && result.message == "Country is blocked") {
          handlebarTemplateJS(
            "#blocked-country",
            '[data-single-results-page="' + tournamentId + '"]',
            {}
          );
        }
      }
    })
    .catch((error) => {
      console.error(error);
    });

  function processSingleTournamentResults(page, data) {
    if (data && data.scoreboard) {
      let scoreboard = data.scoreboard;
      let limit = 10;
      let firstResult = (page - 1) * limit;
      if (firstResult < 0) {
        firstResult = 0;
      }
      data.currentPage = page;
      data.maxPages = Math.ceil(scoreboard.length / limit);

      if (data.maxPages > 10) {
        data.maxPagesToShow =
          page + 9 < data.maxPages
            ? range(page, page + 9)
            : range(data.maxPages - 9, data.maxPages);
      } else {
        data.maxPagesToShow = range(1, data.maxPages);
      }

      data.paginationScoreboard = scoreboard.slice(firstResult, page * limit);
      data.currentUserScoreboard = scoreboard.find(
        (player) =>
          player.playerName.toLowerCase() ===
          ("demoraketech.com_" + settings.username).toLowerCase()
      );
      if (isSinglePageResult) {
        handlebarTemplateJS(
          "#page-single-results-main",
          "[data-page-tournament-results]",
          data
        );
      } else {
        handlebarTemplateJS(
          "#page-single-results-main",
          '[data-single-results-page="' + tournamentId + '"]',
          data
        );
      }
      singleTournamentResultsPagination();
    }
  }

  function singleTournamentResultsPagination() {
    let paginationButton = document.querySelectorAll(
      "[data-single-tournament-results-pagination]"
    );
    paginationButton.forEach((element) => {
      element.addEventListener("click", (e) => {
        let currentTarget = e.currentTarget;
        let page = currentTarget.dataset.singleTournamentResultsPagination;
        processSingleTournamentResults(page, data);
        if (isSinglePageResult) {
          smoothScroll('div[data-single-results-page="' + tournamentId + '"]');
        } else {
          smoothScroll("div[data-page-tournament-results]");
        }
      });
    });
  }
}

function hookTournamentSchedule() {
  const tournamentScheduleComponent = document.querySelector(
    "[data-tournaments-schedule]"
  );
  if (!tournamentScheduleComponent) {
    return;
  }
  let country = window.userCountry === "unknown" ? "" : window.userCountry;
  const parameters = {
    headers: {
      "content-type": "application/json",
      Authorization: settings.token,
      username: settings.username,
      license: settings.pp_wl_game_client_id,
    },
    method: "GET",
    //body: JSON.stringify({ country: country }),
  };
  let queryParams = {};
  if (country) {
    queryParams.country = country;
  }
  let queryParamsObj = new URLSearchParams(queryParams);
  fetch(
    settings.rest_api_url + "getTournamentFullSchedule/?" + queryParamsObj,
    parameters
  )
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else if (response.status == 401 || response.status == 403) {
        return response.json();
      } else {
        throw new Error("Could not reach the API: " + response.statusText);
      }
    })
    .then((result) => {
      if (result.success) {
        var upcomingTournament = [];
        var isliveTournament = [];
        result.data.forEach((eachSchedule) => {
          if (
            eachSchedule.actionButton &&
            eachSchedule.actionButton.additionalHtml.includes(
              "data-wl-game-register-url"
            )
          ) {
            eachSchedule.actionButton.url = settings.pp_wl_game_register_page;
          }
          if (
            eachSchedule.actionButton &&
            eachSchedule.actionButton.additionalHtml.includes(
              "data-wl-game-results-url"
            )
          ) {
            eachSchedule.actionButton.url =
              settings.pp_wl_game_result_page +
              "?tournamentId=" +
              eachSchedule.tournamentId;
          }
          if (eachSchedule.isLive == false) {
            upcomingTournament.push(eachSchedule);
          } else {
            isliveTournament.push(eachSchedule);
          }
        });

        handlebarTemplateJS(
          "#page-tournaments-schedule",
          '[data-tournaments-schedule="live"]',
          { upcomingTournaments: isliveTournament }
        );
        if (upcomingTournament.length > 0) {
          handlebarTemplateJS(
            "#page-tournaments-schedule",
            '[data-tournaments-schedule="upcoming"]',
            { upcomingTournaments: upcomingTournament }
          );
        } else {
          let element = document.querySelector(
            '[data-target=".collapse.upcoming"]'
          );
          element.style.display = "none";
        }
        triggerCollapse();
      } else {
        if (result.message && result.message == "Invalid License Received") {
          handlebarTemplateJS(
            "#invalid-license",
            '[data-tournaments-schedule="live"]',
            {}
          );
        }
        if (result.message && result.message == "Country is blocked") {
          handlebarTemplateJS(
            "#blocked-country",
            '[data-tournaments-schedule="live"]',
            {}
          );
        }
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

function triggerCollapse() {
  const triggers = document.querySelectorAll('[data-toggle="collapse"]');

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.stopImmediatePropagation();
      let element = e.currentTarget;
      let selector = element.getAttribute("data-target");
      collapse(selector, element);
    });
  });

  const collapse = (selector, element) => {
    const targets = document.querySelectorAll(selector);
    targets.forEach((target) => {
      target.classList.toggle("show");
      if (element.classList.contains("collapsed")) {
        element.classList.remove("collapsed");
      } else {
        element.classList.add("collapsed");
      }
    });
  };
}

async function hookUpcomingTournaments() {
  const upcomingTournamentComponent = document.querySelector(
    "[data-upcoming-tournaments]"
  );
  if (!upcomingTournamentComponent) {
    return false;
  }
  let country = window.userCountry === "unknown" ? "" : window.userCountry;
  const parameters = {
    headers: {
      "content-type": "application/json",
      Authorization: settings.token,
      username: settings.username,
      license: settings.pp_wl_game_client_id,
    },
    method: "GET",
  };

  let queryParams = {};
  if (country) {
    queryParams.country = country;
  }
  let queryParamsObj = new URLSearchParams(queryParams);

  try {
    const response = await fetch(
      settings.rest_api_url + "getTournamentFullSchedule/?" + queryParamsObj,
      parameters
    );
    let result;
    if (response.ok) {
      result = await response.json();
    } else if (response.status == 401 || response.status == 403) {
      result = await response.json();
    } else {
      throw new Error("Could not reach the API: " + response.statusText);
    }

    if (result.success) {
      var upcomingTournament = [];
      var isliveTournament = [];
      result.data.forEach((eachSchedule) => {
        if (eachSchedule.isLive == false) {
          upcomingTournament.push(eachSchedule);
        } else {
          isliveTournament.push(eachSchedule);
        }
      });

      handlebarTemplateJS(
        "#page-upcoming-tournaments",
        "[data-upcoming-tournaments]",
        {
          upcomingTournaments:
            upcomingTournament.length == 0 ? false : upcomingTournament,
        }
      );
    } else {
      if (result.message && result.message == "Invalid License Received") {
        handlebarTemplateJS(
          "#invalid-license",
          "[data-upcoming-tournaments]",
          {}
        );
      }
      if (result.message && result.message == "Country is blocked") {
        handlebarTemplateJS(
          "#blocked-country",
          "[data-upcoming-tournaments]",
          {}
        );
      }
    }
  } catch (error) {
    console.error(error);
  }
}

function tournamentBlocks() {
  let tournamentBlocks = document.querySelectorAll("[data-tournament-block]");
  if (tournamentBlocks.length < 1) {
    return false;
  }

  tournamentBlocks.forEach((el) => {
    hookTournamentBlock(el);
  });
}

function getDate(days) {
  var date = new Date();
  if (days) {
    date.setDate(date.getDate() + 7);
  }
  var dd = date.getDate();

  var mm = date.getMonth() + 1;
  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  return yyyy + "-" + mm + "-" + dd;
}

function hookTournamentBlock(el) {
  let language = document.querySelector("#wl-game-integration-plugin").dataset
    .language;
  const tournament = el;
  if (!tournament) {
    return;
  }

  const joinButtons = tournament.querySelectorAll(
    "[data-tournament-block-play]"
  );

  const joinExclusiveButtons = tournament.querySelectorAll(
    "[data-is-exclusive]"
  );

  if (joinButtons.length > 0) {
    joinButtons.forEach((el) => {
      const joinButton = el;
      const tournamentId = joinButton.dataset.tournamentBlockPlay;
      let action = "join";
      const isElementPlayNow = el.getHTML().includes("Play Now");

      joinButton.addEventListener("click", (mainEvent) => {
        if (isElementPlayNow && window.zaraz) {
          zaraz.track("Tournament_Play");
        }
        mainEvent.stopImmediatePropagation();
        joinButton.setAttribute("disabled", true);
        if (joinExclusiveButtons.length > 0) {
          const joinModel = document.querySelector(
            "[data-join-game-exclusive-modal]"
          );
          let modal = document.getElementById("tournamentModal");
          //let btn = document.getElementById("openModel");
          let closeModal = document.querySelector("[data-modal-close]");
          let confirmButton = document.querySelector("[data-modal-confirm]");
          modal.style.display = "block";
          confirmButton.addEventListener("click", (e) => {
            mainEvent.stopImmediatePropagation();
            let parameters = {
              headers: {
                "content-type": "application/json",
                Authorization: settings.token,
                username: settings.username,
                license: settings.pp_wl_game_client_id,
              },
              method: "GET",
              //body: JSON.stringify(data),
            };
            var redeemCodeInput = document.querySelector(
              "[data-redeem-code-input]"
            );
            var redeemCodeValue = redeemCodeInput.value;
            let queryParams = {};
            if (tournamentId) {
              queryParams.tournament_id = tournamentId;
            }
            if (redeemCodeValue) {
              queryParams.tournament_code = redeemCodeValue;
            }
            let queryParamsObj = new URLSearchParams(queryParams);
            fetch(
              settings.rest_api_url + "getTournamentCode/?" + queryParamsObj,
              parameters
            )
              .then((response) => {
                if (response.ok) {
                  return response.json();
                } else {
                  throw new Error(
                    "Could not reach the API: " + response.statusText
                  );
                }
              })
              .then((result) => {
                if (result.success) {
                  joinButton.removeAttribute("disabled");
                  sendGameJoinRequest(
                    {
                      tournament_id: tournamentId,
                      action: action,
                    },
                    joinButton
                  );
                } else {
                  if (result.message) {
                    let errorShow = document.getElementById("errorCheck");
                    errorShow.innerHTML = translate(language, result.message);
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              });
          });

          closeModal.addEventListener("click", () => {
            modal.style.display = "none";
            let errorShow = document.getElementById("errorCheck");
            errorShow.innerHTML = "";
            var redeemCodeInput = document.querySelector(
              "[data-redeem-code-input]"
            );
            redeemCodeInput.value = "";
            joinButton.removeAttribute("disabled");
          });

          window.onclick = function (event) {
            if (event.target == modal) {
              modal.style.display = "none";
              let errorShow = document.getElementById("errorCheck");
              errorShow.innerHTML = "";
              var redeemCodeInput = document.querySelector(
                "[data-redeem-code-input]"
              );
              redeemCodeInput.value = "";
              joinButton.removeAttribute("disabled");
            }
          };
        } else {
          sendGameJoinRequest(
            {
              tournament_id: tournamentId,
              action: action,
            },
            joinButton
          );
        }
      });
    });
  }

  function sendGameJoinRequest(data, joinButton) {
    let parameters = {
      headers: {
        "content-type": "application/json",
        Authorization: settings.token,
        username: settings.username,
        license: settings.pp_wl_game_client_id,
      },
      method: "POST",
      body: JSON.stringify(data),
    };
    fetch(settings.rest_api_url + "startGame/", parameters)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Could not reach the API: " + response.statusText);
        }
      })
      .then((result) => {
        if (result.success) {
          joinButton.removeAttribute("disabled");
          window.location.href =
            settings.pp_wl_game_play_page + "/" + data.tournament_id;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

function range(start, end) {
  var ret = [];
  for (let i = start; i <= end; i++) {
    ret.push(i);
  }
  return ret;
}
